export const STANDALONE_CORE_SEATS = 'standalone-core-seats';